// getSearchResultCountの共通メソッド群

// SearchParamの生成
export function generateSearchParam(form, isReset, free_word = null) {
  const formData = new FormData(form);

  const search_param = {
    jobs_search: {
      // free_wordの整形はバックエンドで行う
      free_word: '',
      category_names: [],
      type_names: [],
      license_names: [],
      area_names: [],
      prefecture_names: [],
      annual_salary_min: '',
      annual_salary_max: '',
      contract_names: [],
      feature_names: [],
    },
  };

  if (!isReset) {
    formData.forEach((value, key) => {
      if (key === 'jobs_search[free_word]') {
        search_param.jobs_search.free_word = free_word ? free_word : value;
      } else if (key.startsWith('jobs_search[category_names][]')) {
        search_param.jobs_search.category_names.push(value);
      } else if (key.startsWith('jobs_search[type_names][]')) {
        search_param.jobs_search.type_names.push(value);
      } else if (key.startsWith('jobs_search[license_names][]')) {
        search_param.jobs_search.license_names.push(value);
      } else if (key.startsWith('jobs_search[area_names][]')) {
        search_param.jobs_search.area_names.push(value);
      } else if (key.startsWith('jobs_search[prefecture_names][]')) {
        search_param.jobs_search.prefecture_names.push(value);
      } else if (key === 'jobs_search[annual_salary_min]') {
        search_param.jobs_search.annual_salary_min = value ? value : '';
      } else if (key === 'jobs_search[annual_salary_max]') {
        search_param.jobs_search.annual_salary_max = value ? value : '';
      } else if (key.startsWith('jobs_search[contract_names][]')) {
        search_param.jobs_search.contract_names.push(value);
      } else if (key.startsWith('jobs_search[feature_names][]')) {
        search_param.jobs_search.feature_names.push(value);
      }
    });
  }

  return search_param;
}

// SearchParamからURLSearchParamsを生成する
export function generateQueryParam(searchParam) {
  // クエリパラメータを生成
  const queryParams = new URLSearchParams();

  // jobs_searchオブジェクトをクエリパラメータに追加
  for (const [key, value] of Object.entries(searchParam.jobs_search)) {
    if (Array.isArray(value)) {
      value.forEach((val) => queryParams.append(`${key}[]`, val)); // 配列の場合は[]を付けて追加
    } else {
      queryParams.append(key, value); // 単一の値の場合はそのまま追加
    }
  }

  return queryParams;
}

// 生成したqueryParamを使って検索結果数を取得する
export async function getSearchResultCount(queryParams) {
  const API_END_POINT = '/api/jobs/search_results_count';
  return await fetch(`${API_END_POINT}?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),
    },
  });
}
